export default function stockInformationModificationInReglement(paramReglement, dataModification) {
  paramReglement.emetteur = dataModification.ligneRemiseBancairePseudoEntity.emetteur;
  paramReglement.referenceReglement = dataModification
    .ligneRemiseBancairePseudoEntity.referenceReglement;
  paramReglement.montantTtc = dataModification.credit - dataModification.debit;
  paramReglement.tiersId = dataModification.tiersId;
  return paramReglement;
}
